module.exports = __webpack_public_path__ + "img/nav-thumbnail-prototypes.ea1dba7c.png";